module.exports = __webpack_public_path__ + "img/moon.0ee55fea.svg";